import i18next from 'i18next';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import { weightUnits } from '../config/commons';
import { TransferData } from '../pages/Sowings/interfaces';

export const generateTransferExcel = async (props: { transferData: TransferData[]; }) => {
  const { transferData } = props;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(i18next.t('stockings.xlsxReport.tabs.transfers'));

  const headerStyle: Partial<ExcelJS.Style> = {
    font: { bold: true, color: { argb: '000000' } },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9D9D9' } },
    alignment: { horizontal: 'center', vertical: 'middle' },
    border: { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
  };

  const header = [
    i18next.t('transfers.unitName'),
    i18next.t('transfers.moduleName'),
    i18next.t('transfers.tankName'),
    i18next.t('transfers.stockingName'),
    i18next.t('transfers.transferName'),
    i18next.t('transfers.stockingDate'),
    i18next.t('transfers.transferDate'),
    i18next.t('transfers.productionDays'),
    i18next.t('transfers.animalsTransferred'),
    i18next.t('transfers.parameters.averageWeight'),
    i18next.t('transfers.biomassTransferred'),
    i18next.t('transfers.parameters.uniformityWeight'),
    i18next.t('transfers.parameters.variationCoefficientWeight'),
    i18next.t('transfers.parameters.maxSmallAnimalsWeight'),
    `% ${i18next.t('transfers.parameters.animals')}`,
    `${i18next.t('transfers.parameters.transferredInCapsule')} ${weightUnits.KG}`
  ];

  const headerRow = worksheet.addRow(header);
  headerRow.eachCell((cell) => (cell.style = headerStyle));

  transferData.forEach((transfer) => {
    const row = [
      transfer.campusName,
      transfer.moduleName,
      transfer.tankName,
      transfer.stockingName,
      transfer.transferName,
      transfer.stockingStartDate,
      transfer.transferDate,
      transfer.productionDays,
      transfer.animalsTransferred,
      transfer.averageWeight,
      transfer.biomassTransferred,
      transfer.uniformityWeight,
      transfer.variationCoefficientWeight,
      transfer.maxSmallAnimalsWeight,
      transfer.smallAnimalsPercentage,
      transfer.transferredWeight,
    ];

    worksheet.addRow(row);
  });

  worksheet.columns.forEach((column) => {
    let maxLength = 10;
  
    if (column.eachCell) {
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value as string;
        if (cellValue) {
          maxLength = Math.max(maxLength, cellValue.toString().length);
        }
      });
    }
  
    column.width = maxLength + 2;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${i18next.t('stockings.xlsxReport.tabs.transfers')}.xlsx`);
};
